export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toISOString().slice(0, 10);
};

export const getTodayDate = () => {
  return formatDate(new Date());
};

export const getMinDateForAge18 = () => {
  const today = new Date();
  const minDate = new Date(today.setFullYear(today.getFullYear() - 18));
  return formatDate(minDate);
};

export const formatPhoneNumber = (input) => {
  if (!input) return '';
  const cleaned = input.toString().replace(/\D/g, '');
  if (cleaned.length !== 10) return input;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export const formatSSN = (input) => {
  if (!input) return '';
  const cleaned = input.toString().replace(/\D/g, '');
  if (cleaned.length !== 9) return input;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
};
